import React, { useEffect } from 'react';
import { Form } from "react-bootstrap";
import { useForm, UseFormRegisterReturn } from "react-hook-form";

const MSG_NAME_PRESENT = "名前を入力してください";
const MSG_EMAIL_PRESENT = "メールアドレスを入力してください";
const MSG_EMAIL_FORMAT = "無効なアドレス形式です";
const MSG_PHONE_PRESENT = "電話番号を入力してください";
const MSG_PHONE_FORMAT = "無効な電話番号形式です";

// メールアドレスの形式チェック
const emailRegexp = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/

interface FieldProps {
  id: string;
  label: string;
  name: string;
  type: string;
  required?: boolean;
  placeholder?: string,
  autoComplete?: string;
  registration: UseFormRegisterReturn;
  errorMessages: string[];
}

const Field = (props: FieldProps) => (
  <Form.Group>
    <Form.Label htmlFor={props.id}>
      {props.label}
    </Form.Label>
    <Form.Control
      id={props.id}
      name={props.name}
      type={props.type}
      placeholder={props.placeholder}
      required={props.required}
      autoComplete={props.autoComplete}
      {...props.registration}
    />
    {props.errorMessages.map((msg, i) => <li key={i} className="text-danger">{msg}</li>)}
  </Form.Group>
);

export interface ValueInterface {
  [key: string]: string;
  name: string;
  email: string;
  phone: string;
}

interface CheckoutFormProps {
  [key: string]: any;
  name?: string;
  email?: string;
  phone?: string;
  onChange?: (value: ValueInterface) => void;
  onValidityChange?: (valid: boolean) => void;
}

const CheckoutForm = (props: CheckoutFormProps) => {
  const { register, watch, setFocus, setValue, formState: { errors, isValid } } = useForm<ValueInterface>({
    mode: "onChange",
    criteriaMode: "all",
    defaultValues: {
      name: '',
      email: '',
      phone: '',
    },
  });

  useEffect(() => {
    setFocus('name');
  }, []);

  const name = watch('name');
  const email = watch('email');
  const phone = watch('phone');

  useEffect(() => {
    props.onChange?.({name, email, phone});
  }, [name, email, phone]);

  useEffect(() => {
    if (props.phone != phone) setValue('phone', props.phone, { shouldValidate: true })
    if (props.email != email) setValue('email', props.email, { shouldValidate: true })
    if(props.name   != name ) setValue('name' , props.name , {shouldValidate: true})
  }, [props.phone, props.email, props.name])

  useEffect(() => {
    props.onValidityChange?.(isValid);
  }, [isValid]);

  return (
    <>
      <fieldset>
          <Field
              label="Name"
              id="name"
              name="name"
              type="text"
              placeholder="Jane Doe"
              required
              autoComplete="name"
              registration={register('name', {
                required: MSG_NAME_PRESENT,
              })}
              errorMessages={[errors.name?.types?.required].filter(Boolean) as string[]} />
          <Field
              label="Email"
              id="email"
              name="email"
              type="email"
              placeholder="janedoe@gmail.com"
              required
              autoComplete="email"
              registration={register('email', {
                required: MSG_EMAIL_PRESENT,
                validate: {
                  format: value => emailRegexp.test(value) || MSG_EMAIL_FORMAT,
                },
              })}
              errorMessages={[errors.email?.types?.required, errors.email?.types?.format].filter(Boolean) as string[]} />
          <Field
              label="Phone"
              id="phone"
              name="phone"
              type="tel"
              placeholder="(941) 555-0123"
              required
              autoComplete="tel"
              registration={register('phone', {
                required: MSG_PHONE_PRESENT,
                validate: {
                  format: value =>
                    // 電話番号の形式は複雑すぎるので桁数のみの確認にとどめる
                    [9, 10, 11, 12, 13, 14, 15].includes(value.replace(/[^0-9０-９]/g, "").length) ||
                    MSG_PHONE_FORMAT,
                },
              })}
              errorMessages={[errors.phone?.types?.required, errors.phone?.types?.format].filter(Boolean) as string[]} />
      </fieldset>
    </>
  );
};

export default CheckoutForm;
